'use strict';

exports.__esModule = true;

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Title =
/*#__PURE__*/
(0, _reactEmotion2.default)('h2', {
  target: 'e1hnx4sx0'
})('margin:0 0 8px;font-size:1rem;color:', function (_ref) {
  var theme = _ref.theme;
  return theme.colors.titleColor;
}, ';');
exports.default = Title;